import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { handleLogin, openModal, updateUserSession } from '../../redux/actions';
import SlideInModal from "../../containers/SlideInModal";
import InputList from '../InputList';
import Input from '../Input';
import Checkbox from '../Checkbox';
import { FacebookIcon, GoogleIcon } from '../../utils';

import { FormFooter, LoginButton, SignUpButton, ErrorMessage, ForgotButton, LoginSocial, LoginSocialButton } from './styles';

const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('Email is required'),
  password: Yup.string()
    .min(8, 'Password is too short. Minimum length is 8 characters')
    .required('Password is required'),
});

const { Item } = InputList;
const { Heading, Description } = SlideInModal;

class LoginModal extends Component {
  static propTypes = {
    name: PropTypes.string,
    loginError: PropTypes.string,
    handleUserLogin: PropTypes.func,
    handleModalCall: PropTypes.func,
    handleSessionUpdate: PropTypes.func,
    isClosable: PropTypes.bool,
  };

  static defaultProps = {
    isClosable: true,
  };

  componentDidMount() {
    window.addEventListener('message', this.onMessageHandler);
    window.addEventListener('storage', this.onStorageHandler);
  };

  componentWillUnmount() {
    window.removeEventListener('message', this.onMessageHandler);
    window.removeEventListener('storage', this.onStorageHandler);
  }

  onMessageHandler = evt => {
    if (evt.origin && evt.origin !== window.location.origin) return;

    const { data } = evt;
    const { handleSessionUpdate } = this.props;

    if (data === 'auth') {
      handleSessionUpdate(null);
    }
  };

  onStorageHandler = evt => {
    if (evt.key !== 'dayaxe-oauth-event' || !evt.newValue) return;

    const { handleSessionUpdate } = this.props;

    if (evt.newValue.indexOf('auth:') === 0) {
      handleSessionUpdate(null);
    }
  };

  render() {
    const { name, handleUserLogin, loginError, handleModalCall, isClosable } = this.props;

    return (
      <SlideInModal name={name} isClosable={isClosable}>
        <Heading>
          Login to <span>Dayaxe</span>
        </Heading>
        <Description>
          Welcome back, please login <br /> to your account
        </Description>
        <LoginSocial>
          <li>
            <LoginSocialButton onClick={() => window.open(`${process.env.API_URL}users/facebook/login`, 'Login with Facebook', 'width=500, height=600')}>
              <FacebookIcon />
              Login with Facebook
            </LoginSocialButton>
          </li>
          <li>
            <LoginSocialButton onClick={() => window.open(`${process.env.API_URL}users/google/login`, 'Login with Google', 'width=500, height=600')}>
              <GoogleIcon />
              Login with Google
            </LoginSocialButton>
          </li>
        </LoginSocial>
        <Formik
          initialValues={{
            email: '',
            password: '',
            remember: true,
          }}
          validationSchema={LoginSchema}
          onSubmit={values => handleUserLogin(values, values.remember)}
        >
          {({ errors, touched, handleBlur, handleChange, values }) => (
            <Form>
              <InputList>
                <Item>
                  <Input
                    htmlType="text"
                    name="email"
                    autocomplete="email"
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    value={values.email}
                    hasError={errors.email && touched.email}
                    placeholder={errors.email || 'Enter email'}
                    floatingPlaceholder
                  />
                </Item>
                <Item>
                  <Input
                    htmlType="password"
                    name="password"
                    autocomplete="current-password"
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    value={values.password}
                    hasError={errors.password && touched.password}
                    placeholder={errors.password || 'Enter password'}
                    floatingPlaceholder
                  />
                </Item>
              </InputList>
              {loginError && <ErrorMessage>{loginError}</ErrorMessage>}
              <FormFooter>
                <Checkbox
                  label="Remember me"
                  name="remember"
                  value="remember"
                  id="remember"
                  blue
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  checked={values.remember}
                  normal
                  onChange={handleChange}
                />
                <ForgotButton type="button" onClick={() => handleModalCall('forgot')}>Forgot password</ForgotButton>
              </FormFooter>
              <LoginButton type="submit" btnType="primary">
                Login
              </LoginButton>
              <SignUpButton type="button" onClick={() => handleModalCall('registration')}>Sign Up</SignUpButton>
            </Form>
          )}
        </Formik>
      </SlideInModal>
    )
  }
}

const mapStateToProps = state => ({
  loginError: state.user.errors.login,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleUserLogin: handleLogin,
  handleModalCall: openModal,
  handleSessionUpdate: updateUserSession,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);
